// Group 			dffd9056-90c2-4514-88b2-0bc4bc58af9d
// MPEC 			16d325d7-5ce6-4a5f-b540-fd12af03ea47
// iBlocks 			23f199a2-eb34-436d-90e4-9c296c5742b3
// Tracsis US 		e2605939-3e58-4311-841e-b4828550ab8b
// Traffic Data 	e486c3a3-4c39-477f-9751-6630f4573907
// Rail Ops 		a592c9d8-7829-4322-876a-920c3c564286
// Consultancy		8a951812-95c2-42b3-9ee4-e308225585a8
// Events			92adc2cc-17f9-4383-af83-e0badb65cac7

export const SERVICES = {
	GROUP: {
		value: 'group',
		label: 'Group',
		uuids: ['dffd9056-90c2-4514-88b2-0bc4bc58af9d'],
	},
	OPS: {
		value: 'operations-planning',
		label: 'Operations and Planning',
		uuids: ['a592c9d8-7829-4322-876a-920c3c564286'],
	},
	CX: {
		value: 'custom-experience',
		label: 'Customer Experience',
		uuids: ['23f199a2-eb34-436d-90e4-9c296c5742b3'],
	},
	DIGITALRAILWAY: {
		value: 'digital-railway',
		label: 'Digital Railway',
		uuids: [
			'16d325d7-5ce6-4a5f-b540-fd12af03ea47',
			'e2605939-3e58-4311-841e-b4828550ab8b',
		],
	},
	TRAFFICDATA: {
		value: 'traffic-data',
		label: 'Traffic Data',
		uuids: ['e486c3a3-4c39-477f-9751-6630f4573907'],
	},
	ETM: {
		value: 'event-traffic-management',
		label: 'Event Traffic Management',
		uuids: ['92adc2cc-17f9-4383-af83-e0badb65cac7'],
	},
	DATAINFORMATICS: {
		value: 'data-informatics',
		label: 'Data Informatics',
	},
	CONSULTANCY: {
		value: 'consultancy',
		label: 'Consultancy',
		// uuids: ['8a951812-95c2-42b3-9ee4-e308225585a8'],
	},
};
